var Backbone = require('backbone'),
    _ = require('underscore'),
    NoteUIModel = require('./noteUI'),
    fvChannel = require('glRadio').channel('FV');


var instVars = {
    uiModel: null, //for the note view
    parentFlashBackNote: null //ew: there for FB notes being created ... THESE MUST GET EXTENDED .... that was hack

    /* noteTypeGroup:
        - don't make attribute: java jackson parser will throw exception for unknown attributes, so make instance var
        - but don't put in this -- parse called b/f init so it will be overwritten
        - I'm sure there's a better pattern here to see for clarity of the instance vars
    */
    // noteTypeGroup: null

    // those used as flags ....
    //isText: undefined //--> isText()
    //isDocument
};


module.exports = Backbone.Model.extend({

    ViewConstructor: require('../views/note/note'),

    NoteUIModel: NoteUIModel,

    // put this in constructor ???
    initialize: function( attrs, options ) {

        /**
         * TODO: issue -- since parse is called from constructor 1st, UI model may not be new yet if we need to update the properties
         * put in constructor?
         * see textStamp.parse
         */
        // ( see textStamp )
        _.extend( this, instVars, {
           uiModel: new this.NoteUIModel({ parent: this} )
        });

        // Allow to set the page number if provided
        if ( options.pageNumber ) {
            this.pageNumber = options.pageNumber;
        }

    },

    parse: function(resp, options) {
        // add noteTypeGroup to the attributes
        // this better handled server-side but then need to do with that arch: doing note logic like this in other places on client anyway ...

        // put logic on base note and avoid putting on prototypes:  _.result(this, 'noteTypeGroup')
        // .. this is b/c if save, for instance, a keyed text note, the text note model wont have a noteTypeGroup defined
        // .. though if 'ifs' get out of control, could put function on the parent type -- eg the text note
        var noteType = resp.noteType,
            noteTypeGroup = noteType;

        if (noteType === 'HTML_NOTE') noteTypeGroup = 'TEXT_NOTE';
        if (noteType === 'KEYED_TEXT_NOTE') noteTypeGroup = 'TEXT';
        if (noteType === 'SVG_GRAPHIC_NOTE') noteTypeGroup = 'GRAPHIC_NOTE';
        if (noteType === 'FLOATING_REDACTION_NOTE') noteTypeGroup = 'REDACTION_NOTE';

        this.noteTypeGroup = noteTypeGroup;

        return resp;
    },

    getNoteTypeGroup: function() {
        return this.noteTypeGroup;
    },

     //the text to search from the model data in note view for the SAT filter
    textToFilter: function() { 

        var ctime =  this.get('creationTime'),
            cuser =  this.get('creationUserDesc'),
            pgNum =  'p.'+ this.pageNumber,
            title = this.get('title'),
            text = this.get('text'),
            //accessGroup = this.get('accessGroupName'),
            consultGroupNames = this.getConsultGroupNames();

        return (ctime ? ctime : '') + (cuser ? cuser : '') +
            (pgNum ? pgNum: '') + (title ? title : '') + (text ? text: '') +
            //(accessGroup ? accessGroup: '') // for now NOT doing may not be shown
            (consultGroupNames ? consultGroupNames: '');


    },

    /**
     * TODO:
     * - subclass into different models
     * - ability to return multiple validation error messages
     * - perhaps subclass into F&R
     * - doesn't look like we use the numer any more
     */
    validate: function( attrs, options ) {

        var errObj = {
            num: null, //'enum' causes error ie8 -- ENUM IS RESERVED WORD IE8 AND LOWER -- TODO: still used?
            message: null
        };

        /*
        * Validate 'title' for page notes -- it exists on all note types but it's only exposed in the UI for drawable page notes.
        * Document text notes and flash notes don't send on create, only on modify.
        * Page text notes send to the server but don't expose the interface.
        * For page notes, the default is the note type description, which doesn't exceed the threshold.
        * Threshold for Doc Notes is 2000; for Page Notes it's 32.
        * */
        if ( this.isPageNote() ) {

            var maxTitleCharacters = fvChannel.request('getPageNoteTitleMaxLength');

            if ( attrs.title && attrs.title.length > maxTitleCharacters ) {
                errObj.message = "Subject cannot exceed " + maxTitleCharacters + " characters.";
                return errObj;
            }

        }

        // Full Page Redaction -- If Denied In Full at Least One Reason Code Must Be Selected
        // Note: for this type, there will only ever be one shape
        if ( this.isFullPageRedactionNote() ) {

            var reasonCodes = _.pluck( attrs.shapes[0].reasonCodes, 'code' ),
                isDeniedInFull = !_.contains( reasonCodes, fvChannel.request('constants').NON_RESPONSIVE_REASON_CODE );

            if ( isDeniedInFull && reasonCodes.length < 1 ) {
                errObj.message = 'Denied in Full redactions must have at least one reason code applied.';
                return errObj;
            }

        }

        if  ( this.isDrawable() ) {

            // Don't allow if there are no shapes
            var shapesAttr;

            if ( this.isSvgNoteType() ) {

                shapesAttr = attrs.text;

            } else if ( this.isGraphicStamp() ) {
                /**
                 * For this type, there is x, y, width, height.
                 * Just look at x, if there is none, the shape was new and the user never placed it down
                 * Note: there should also be a shape (validation should not fail)
                 */
                shapesAttr = attrs.x;
            } else {

                // Original coordinate notes
                shapesAttr = attrs.shapes;
            }

            if (!shapesAttr || shapesAttr.length < 1) {
                errObj.message = 'Cannot save ' + this.desc + ' note without any shapes.';
                return errObj;
            }


            if ( this.isTextStamp() && this.uiModel.hasVariableInputs() ) {

                if ( !this.uiModel.getVariableInputs().allInputsAreValid() ) {
                    errObj.message = 'Cannot save stamp: not all variable inputs entered.';
                    return errObj;
                }

            }


        }  else {

            if (!attrs.text || attrs.text.length < 1) {

                errObj.message = 'No message entered.';

                /**
                 * Server will return null text, which would result for flash notes by design, resulting in 'false' validation error.
                 * ( When opened, the text will be fetched on demand ).
                 * Only deem invalid if the text is empty before it's sent to the server.
                 * options.xhr will not exist on entry
                 */
                if ( this.isFlashNote() ) {

                    if (!(options.xhr && options.xhr.status === 200))
                        return errObj;
                }
                else {
                    return errObj;
                }
            }



        }

    },

    /*
    *  Wraps BB model changedAttributes function.
    *  If note hasn't changed return false (like Backbone's changedAttributes), otherwise returns the changed attributes.
    *  Called for edited notes on save/cancel; new (by default) haven't changed --
    *  Update: also called for new notes ( central notes:changedNoteAttributes request )
    *  Merges note attrs and shape attrs.
    * */
    hasNoteChanged: function( noteAttrs, shapeAttrs ) {

        // title NA for document
        if (this.isDocument)
            delete noteAttrs.title;

        /*
        * TODO: do this on parse of shapes
        * never needed (but sent in resp) -- could also fill in shape val
        *  forget what was going on here ...
        * */
        if ( this.get('shapes') ) {
            _.each( this.get('shapes'), function(s) {
                delete s.unitType;
            });
        }

        return this.changedAttributes(
            shapeAttrs
                ? _.extend( {}, noteAttrs, shapeAttrs )
                : noteAttrs
        );

    },
    /*
    * TODO: mediate, put back on view -- and if not at least break up into diff models for the conditionals.
    * Sanitize input from the note view -- somewhat like computed/derived properties.
    * This has evolved to generate the appropriate JSON to save the notes ... refactor necessary.
    * We now have new interfaces for find and redact necessary to see if edit required ... REFACTOR necessary or make model driven.
    * */
    sanitizeUserInput: function(inputs, user) {

        /*
        * Note: for now privateGroups are stored on user ... should be moved.
        * Shouldn't need to send back ids AND names for access / consult groups --
        * should be handled by server ... actually, server should handle a lot of this
        * */
        var isNew = this.isNew(),
            isFlashNote = this.isFlashNote(),
            isFlashBack = this.parentFlashBackNote, /* only stored as flag on model -- if so, don't take from ui but the parent note itself */

            // access groups:
            defaultAccessGroup = user.defaultNoteAccessGroup(isFlashNote),
            accessGroup = (!this.isDocument || isFlashNote)
                ? isFlashBack /* its assumed to be the parent flashback, so not in the ui */
                    ? this.parentFlashBackNote.get('creationUserPrivateGroup')
                    : parseInt(inputs.accessibleByVal) //must be page -- it is printed (doesn't matter new/modified)
                : isNew
                    ? defaultAccessGroup.id //if not saved, used the default (public)
                    : this.get('accessGroup'),/* it's modified and not shown -- it didn't change -- leave it */
            accessGroupName = (!this.isDocument || isFlashNote)
                ? isFlashBack
                    ? this.parentFlashBackNote.get('accessGroupName')
                    : inputs.accessibleByName
                : isNew
                    ? defaultAccessGroup.name //if not saved, used the default
                    : this.get('accessGroupName'); /* it's modified and not shown -- it didn't change -- leave it */

        var sanitizedAttrs = {
            title: inputs.noteSubject === '' ? this.desc : inputs.noteSubject,
            text: inputs.text === '' ? null : inputs.text,
            accessGroup: accessGroup,
            accessGroupName: (accessGroup === user.get('privateGrpId'))
                ? user.get('description')
                : accessGroupName,  // if the access group is the current user, it's displayed as 'Me', replace with the actual description of the user
            noteStatus: inputs.autoDisplayChecked ? 'V' : 'I'
        };

        if ( this.isGraphicStamp() ) {
            // graphic stamps should always have auto-display applied, but FDD save them with a value of 'I'
            // quick hack here to ensure it's always saved as 'I'
            sanitizedAttrs.noteStatus = 'I';
        }

        // for flash note -- this wasn't validated and the keys above have diff names, can't extend
        // TODO: should have diff model class
        _.has( inputs, 'sendEmail') && _.extend( sanitizedAttrs, {sendEmail: inputs.sendEmail} );

        /*
        * Note: consults groups are already sanitized, here putting them on the object to persist.
        * TODO: ifReviewGroups apply and then consultGroups apply for each --- refactor
        * TODO: need to see if  fvChannel.request('supportConsults') -- if it doesn't, none should be sent so prob not an issue
        * */
        if ( this.consultGroupsApply() ) {

            // Note clean, but this will work instead of sending a null value if none of the potential review types are there.
            // Send a null if there are none for each would also work, but would require more logic.
            sanitizedAttrs['reviewGroups'] = {
                'consultation': inputs.consultGroups
            };
        }

        return sanitizedAttrs;

    },
    isDrawable: function() {
        return this.draw; //from the xref -- can return null
    },
    /* derived from flags ... */
    isTextNote: function() { //doc text or pg text note
        return this.isText;  //flag present on text note xrefs
    },
    isPageNote: function() {
        return !this.isDocument;
    },
    getNoteClass: function() {
        return 'pn-' + this.init;
    },
    getIconHoverLbl: function() {
        var desc = this.desc,
            aDesc = desc.split(' ');
        return aDesc.length > 1 ? desc : desc + ' Note';
    },
    /* derived (from server attrs) ... */
    getSubject: function(includeQuotes) { //used in rendering subject field in notes
        var title = this.get('title');
        if (includeQuotes) {
            return (title ? '"' + title + '"' : this.desc + ' Note');
        } else {
            return (title ?  title : this.desc + ' Note');
        }
    },
    getNoteType: function() {
        return this.get('noteType');
    },
    isPageTextNote: function() {
        return this.get('noteType') === 'TEXT' || this.get('noteType') === 'KEYED_TEXT_NOTE';
    },
    autoDisplayNote: function() {
        return this.get('noteStatus') === 'V';
    },
    isFlashNote: function() {
        return this.get('noteType') === 'FLASH_NOTE';
    },
    isSignature: function() {
        return this.get('noteType') === 'SVG_SIGNATURE';
    },
    isSVGGraphicNote: function () {
        return this.get('noteType') === 'SVG_GRAPHIC_NOTE';
    },
    isFDDGraphicNote: function() {
        return this.get('noteType') === 'GRAPHIC_NOTE';
    },
    isActivityNote: function() {
        return this.get('noteType') === 'ACTIVITY_NOTE';
    },
    isGraphicStamp: function() {
        return this.get('noteType') === 'GRAPHIC_STAMP';
    },
    isTextStamp: function() {
        return this.get('noteType') === 'GRAPHIC_TEXT_STAMP';
    },
    isHighlightNote: function() {
        return this.get('noteType') === 'HIGHLIGHT_NOTE';
    },
    /* -- Redaction -- */
    isRedactionNote: function() {
        return this.isNonFullpageRedactionNote() || this.isFullPageRedactionNote();
    },

    // 'Regular' Redaction Notes
    isNonFullpageRedactionNote: function() {
        return this.get('noteType') === 'REDACTION_NOTE' || this.get('noteType') === 'FLOATING_REDACTION_NOTE';
    },

    // Note: this assumes no conversion
    isFloatingRedaction: function() {
        return this.get('noteType') === 'FLOATING_REDACTION_NOTE';
    },

    isFullPageRedactionNote: function() {
        return this.get('noteType') === 'FULL_PAGE_REDACTION';
    },

    isRedactionNoteConvertingToFloatingCodes: function() {
        // (latter is only ever a property of redaction notes)
        return this.get('noteType') === 'REDACTION_NOTE' && this.isConvertingToFloatingCodes;
    },

    isFloatingRedactionAndSystemNotSetForFloatingCodes: function() {
        return this.get('noteType') === 'FLOATING_REDACTION_NOTE' && !this.systemIsSetToFloatingCodes;
    },

    isSvgNoteType: function() {
        return this.isSVGGraphicNote() || this.isSignature() || this.isTextStamp();
    },


    /* -- End Redaction --*/


    supportsHoverShape: function() {
        return this.isGraphicStamp() || this.isSignature() || this.isTextStamp();
    },


    /* --- consult groups --- */
    // make a sub-object?

    getReviewGroups: function() {
        return this.get('reviewGroups');
    },
    hasReviewGroups: function() {
        var grps = this.getReviewGroups();
        return grps && _.keys(grps).length > 0;
    },


    /* may not be applicable to the base type, but will be called on for note types where it doesn't apply -- may want to change this */

    consultGroupsApply: function() {
        return this.consultsApplicable;
    },

    // store on model now that we have different type of note views (eg find and redact)
    showConsultGroupSelectorOnNoteViews: function() {
        return fvChannel.request('supportConsults') && this.consultGroupsApply();
    },

    // return the consult groups array directly from the object or null if none exist
    // TODO: may want to parse these and put on child obj ??? ... get going and see later

    getConsultGroups: function() {

        if ( !this.hasReviewGroups() )
            return null;

        var consultGrps = this.getReviewGroups().consultation; // now superfluous; and this needs to be in another object ...

        return consultGrps && consultGrps.length > 0
            ? consultGrps
            : null;

    },

    // TODO: introduces stronger need for separate objects as this should be CACHED (done on keydown ... also another fn)
    // return string of all consult group names for filtering or null if none are assigned
    getConsultGroupNames: function() {
        var consultGrps = this.getConsultGroups();
        return consultGrps
            ? _.pluck(consultGrps, 'name').join('')
            : null;
    },

    consultGroupsAssigned: function() {
        return this.getConsultGroups() !== null;
    },

    /*
    * Return the color to apply to note shape derived from note's consultGroups.
    * This is what's currently in the db -- it's unaffected by user changes between saving the note.
    * Derived: if there is 1 assigned, return the color of that assignment; if there are > 1, return null (so the default color will apply)
    * If there are no groups or none is assigned, will return null.
    * If consultGroups provided, uses those groups to derive the color, instead of that stored on the note.
    * TODO: put on drawable note only?
    * */
    getConsultColorForShapes: function( consultGroups ) {

        consultGroups = consultGroups ? consultGroups : this.getConsultGroups();

        if (!consultGroups)
            return null;

        return consultGroups.length === 1
            ? consultGroups[0].color
            : null;

    },
    /*
    * Return the not necessarily saved, derived consult group color as it's currently set in the UI
    * */
    getCurrentConsultColorForShapes: function() {
        return this.uiModel.getCurrentConsultColorForShapes();
    },
    /*
    * Now necessary because we're displaying the 'current' color from that stored on on the UI model.
    * when changed in the UI, it is changed directly.
    * If not changed back on cancel, the note's color (and it's shapes on the canvas) won't be reset.
    * Now only used for this purpose; other persisted attributes are stored on the note model,
    * and aren't changed immediately with changes to the UI ( values are retrieved from the UI on save )
    * potential opportunity for refactor if more properties like this are introduced in the future.
    * */
    resetOnCancelChanges: function() {

        this.uiModel.resetOnCancelChanges( this.getConsultColorForShapes() );

    }

});





/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/models/note.js
 ** module id = 153
 ** module chunks = 0
 **/